import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import CampaignList from '../views/CampaignList.vue'
import CampaignEdit from '../views/CampaignEdit.vue'
import MaterialList from '../views/MaterialList.vue'
import MediaSlotList from '../views/MediaSlotList.vue'
import ReportsCenter from '../views/ReportsCenter.vue'
import Login from '../views/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard
  },
  {
    path: '/campaigns',
    name: 'CampaignList',
    component: CampaignList
  },
  {
    path: '/campaigns/create',
    name: 'CampaignCreate',
    component: CampaignEdit
  },
  {
    path: '/campaigns/edit/:id',
    name: 'CampaignEdit',
    component: CampaignEdit
  },
  {
    path: '/materials',
    name: 'MaterialList',
    component: MaterialList
  },
  {
    path: '/media-slots',
    name: 'MediaSlotList',
    component: MediaSlotList
  },
  {
    path: '/reports',
    name: 'ReportsCenter',
    component: ReportsCenter
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 添加路由守卫，保护需要登录的页面
router.beforeEach(async (to, from, next) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
  
  // 如果访问的不是登录页，且用户未认证，则重定向到登录页
  if (to.path !== '/login' && !isAuthenticated) {
    next({ path: '/login', query: { redirect: to.fullPath } });
  } else {
    // 确保在每次路由切换（包括刷新页面）时获取DSP配置
    if (Vue.prototype.$getDspConfig) {
      await Vue.prototype.$getDspConfig();
    }
    // 正常访问
    next();
  }
});

export default router 
